import React, { useEffect, useRef, useState } from 'react';
import './RowActionsMenu.css';
import ReportOverlay from './ReportOverlay';

// Standard toolbar-level report control (pat-architecture-reports-ui-standard.md):
// one "Print ▾" dropdown offering every report option for the current
// screen, instead of a separate button per report type. Reuses the kebab
// row-actions menu's dropdown styling for visual consistency.
//
// `options`: [{ key, label, onSelect }] — the parent screen owns whatever
// data-fetching a selection triggers.
// `activeContent`: the currently open report's rendered JSX (or null) —
// shown in a ReportOverlay. The parent owns which report is "active".
function ReportLauncher({ label = 'Print ▾', options, activeContent, onCloseActive }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <>
      <div className="row-actions-menu" ref={containerRef}>
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-haspopup="true"
          aria-expanded={open}
          style={{ padding: '5px 14px', background: '#fff', color: '#1976d2', border: '1px solid #1976d2', borderRadius: 6, fontWeight: 500, cursor: 'pointer' }}
        >
          {label}
        </button>
        {open && (
          <div className="row-menu-dropdown" style={{ left: 'auto', right: 0, minWidth: 220, whiteSpace: 'nowrap' }}>
            {options.map((option) => (
              <button
                key={option.key}
                type="button"
                className="row-menu-item"
                onClick={() => { setOpen(false); option.onSelect(); }}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeContent && (
        <ReportOverlay onClose={onCloseActive}>
          {activeContent}
        </ReportOverlay>
      )}
    </>
  );
}

export default ReportLauncher;
